import React from "react";
import { Col, Row } from "react-bootstrap";
import Skeleton from "react-loading-skeleton";
import PaymentsOutline from "@mui/icons-material/PaymentOutlined";

const SkeletonReserveItem = () => {
  return (
    <ul className="mt-4 px-0" style={{ listStyle: "none" }}>
      <li className=" mb-5 border rounded-4 border-dark-blue bg-light-blue">
        <div className="bg-dark-blue pb-2 pt-4 pl-2 rounded-4 text-white rounded-bottom-0">
          <Skeleton width={120} height={25} />
        </div>

        <div className="border border-light-blue bg-white rounded-4 pb-3 px-4 m-3 mb-4">
          <Row className="border-bottom mb-3 pt-4 rounded-4 rounded-bottom-0 pb-5">
            <Col className="text-danger">
              <Skeleton width={180} height={25} />
            </Col>
          </Row>
          <Row className="py-4 py-xl-0  border-bottom item-box">
            <Col xl="3" className="mb-3 my-xl-auto py-xl-4">
              <Skeleton width={100} height={25} />
            </Col>
            <Col sm md xl className="mt-3 mt-xl-0 ps-sm-0 py-xl-4">
              <Row>
                <Col
                  xs="6"
                  sm="12"
                  className="font-size-xs text-secondary mb-md-2"
                >
                  نرخ مصوب
                </Col>
                <Col
                  xs="6"
                  sm="12"
                  className="text-start text-sm-end mt-sm-2 mt-xl-0 text-decoration-line-through"
                >
                  <Skeleton width={100} height={25} />
                </Col>
              </Row>
            </Col>
            <Col sm md xl className="mt-3 mt-xl-0 ps-sm-0 py-xl-4">
              <Row>
                <Col
                  xs="6"
                  sm="12"
                  className="font-size-xs text-secondary mb-md-2"
                >
                  نرخ فروش
                </Col>
                <Col
                  xs="6"
                  sm="12"
                  className="text-start text-sm-end mt-sm-2 mt-xl-0"
                >
                  <Skeleton width={100} height={25} />
                </Col>
              </Row>
            </Col>
            <Col sm md className="mt-3 mt-xl-0 ps-sm-0 py-xl-4">
              <Row>
                <Col
                  sm="12"
                  xs="6"
                  className="font-size-xs text-secondary mb-md-2"
                >
                  کمیسیون
                </Col>
                <Col
                  sm="12"
                  xs="6"
                  className="text-start  text-sm-end  mt-sm-2 mt-xl-0"
                >
                  <Skeleton width={100} height={25} />
                </Col>
              </Row>
            </Col>
            <Col sm md xl className="mt-3 mt-xl-0 ps-sm-0 py-xl-4">
              <Row>
                <Col
                  sm="12"
                  xs="6"
                  className="font-size-xs text-dark-blue mb-md-2"
                >
                  <PaymentsOutline /> مبلغ قابل پرداخت
                </Col>
                <Col
                  sm="12"
                  xs="6"
                  className="font-weight-bold text-dark-blue font-size-lg text-start text-sm-end mt-sm-2 mt-xl-0"
                >
                  <Skeleton width={100} height={25} />
                </Col>
              </Row>
            </Col>
            <Col
              sm="1"
              md="2"
              lg="1"
              xl="1"
              className="mt-3 mt-xl-0 ps-sm-0 pl-sm-2 py-xl-4"
            >
              <Row>
                <Col
                  sm="12"
                  xs="6"
                  className="font-size-xs text-secondary mb-md-2"
                >
                  موجودی
                </Col>
                <Col
                  sm="12"
                  xs="6"
                  className="text-start text-sm-end mt-sm-2 mt-xl-0"
                >
                  <Skeleton width={50} height={25} />
                </Col>
              </Row>
            </Col>
            <Col sm md xl className="mt-3 mt-xl-0 py-xl-4">
              {/* ******** */}
              <Row>
                <Col
                  sm="12"
                  xs="6"
                  className="font-size-xs text-secondary my-auto mb-md-2"
                >
                  تعداد
                </Col>
                <Col
                  sm="12"
                  xs="6"
                  className="text-start text-sm-end mt-sm-2 mt-xl-0"
                >
                  <Skeleton width={100} height={25} />
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      </li>
    </ul>
  );
};
export default SkeletonReserveItem;
